export default {
  path: "/pdfH5",
  name: "pdfH5",
  component: () => import("@/views/Page.vue"),
  children: [
    {
      path: "email",
      component: () => import("@/components/pdf2H5/email.vue"),
      meta: {
        title: "邮箱归档方法",
        title1: "360.cn集团邮箱归档方法"
      }
    },
    {
      path: "iphoneEmail",
      component: () => import("@/components/pdf2H5/iphoneEmail.vue"),
      meta: {
        title: "手机邮箱使用",
        title1: "360.cn集团手机邮箱使用V5.0"
      }
    },
    {
      path: "specialEmail",
      component: () => import("@/components/pdf2H5/specialEmail.vue"),
      meta: {
        title: "专用邮箱邮件组",
        title1: "360.CN专用邮箱邮件组使用手册"
      }
    },
    {
      path: "changeEmailPass",
      component: () => import("@/components/pdf2H5/changeEmailPass.vue"),
      meta: {
        title: "邮箱密码更改使用手册",
        title1: "360.CN邮箱密码更改使用手册"
      }
    },
    {
      path: "transfer",
      component: () => import("@/components/pdf2H5/transfer.vue"),
      meta: {
        title: "转签温馨提示"
      }
    },
    {
      path: "meeting",
      component: () => import("@/components/pdf2H5/meeting.vue"),
      meta: {
        title: "360-电话会议使用手册"
      }
    }
  ]
};
